// src/pages/ProductDetail.js
import { useParams } from 'react-router-dom';
import './ProductDetails.css';

const productData = {
  1: {
    title: 'Classic Photo Book',
    description: 'This timeless hardcover photo book includes up to 100 pages and is ideal for anniversaries, family albums, and portfolios.',
    images: [
      '/assets/classic1.png',
      '/assets/classic2.png',
      '/assets/classic3.png',
    ]
  },
  2: {
    title: 'Wedding Album',
    description: 'Our luxury wedding albums feature elegant layouts, metallic foils, and lay-flat binding for full-spread photos.',
    images: [
      '/assets/wedding1.png',
      '/assets/wedding2.png',
      '/assets/wedding3.png'
    ]
  },
  3: {
    title: 'Baby’s First Year',
    description: 'Capture your baby’s first smiles, steps, and stories in this adorable customizable album with soft pastel themes.',
    images: [
      '/assets/baby3.jpg',
      '/assets/baby3.jpg',
      '/assets/baby3.jpg'
    ]
  },
  4: {
    title: 'Travel Memories',
    description: 'A softcover or hardcover option for documenting your journeys with a map feature, text overlays, and location markers.',
    images: [
      '/assets/travel4.png',
      '/assets/travel2.png',
      '/assets/travel3.png'
    ]
  }
};

export default function ProductDetail() {
  const { id } = useParams();
  const product = productData[id];

  if (!product) return <div>Product not found.</div>;

  return (
    <div className="product-detail">
      <h1>{product.title}</h1>
      <p>{product.description}</p>

      <div className="detail-gallery">
        {product.images.map((src, index) => (
          <img key={index} src={src} alt={`${product.title} ${index}`} />
        ))}
      </div>
      <a href="/contact#contact-form" className="primary-btn">Customize Yours</a>
    </div>
  );
}
